export default "__VITE_ASSET__CqkVvBHt__"